<div class="section mx-3 my-3">
    @if(showEditButton){
    <div class="d-flex justify-content-end mb-3">
        <button class="btn btn-warning" (click)="openEditPopup()">Edit Travel Details</button>
    </div>
    }

    @if(!rejected){
    <h2 class="text-success">Approved Lenders</h2>
    <div class="card-container">
        <div class="lender-card row align-items-center p-3" *ngFor="let lender of approvedLenders"
            [class.disabled]="!lender.isEnabled">

            <!-- Logo & Name -->
            <div class="col-12 col-md-2 d-flex flex-column align-items-center mb-2 mb-md-0">
                <h3 class="mb-0">{{ lender.lender }}</h3>
                <img [src]="lender.logo" [alt]="lender.lender + ' logo'" class="logo me-2">
            </div>

            <!-- Lender Details Row -->
            <div class="col-12 col-md-8 row">
                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>Loan Amount:</strong> {{
                    getLoanAmountRange(lender.plans) | currency: 'INR':'symbol':'1.0-0' }}</div>
                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>Tenure:</strong> {{
                    getTenureRange(lender.plans) }}</div>
                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>Interest:</strong> {{
                    getInterestRange(lender.plans) }} p.m</div>

                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>EMI starts from:</strong> ₹{{
                    getMinEmi(lender.plans) | number }}</div>

                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>APR:</strong> {{ getAprRange(lender.plans) }}
                    p.a
                </div>
                <div class="col-6 col-lg-2 info-item mb-1 mb-lg-0"><strong>Penal Charges:</strong> {{
                    lender.penalCharges
                    }} <i *ngIf="lender.penalChargesDesc" class="fa fa-info-circle ms-1" [title]="lender.penalChargesDesc" style="cursor: pointer; color: #044b5f;"></i></div>
            </div>

            <!-- Action Buttons -->
            <div class="col-12 col-md-2 text-md-end mt-2 mt-md-0" [class.hide]="!lender.isEnabled">
                <button *ngIf="lender.continue && CanContinue(lender)" class="btn-continue w-100"
                    (click)="continueApplication(lender)">
                    Continue
                </button>
                <button *ngIf="!lender.continue || (lender.continue && !CanContinue(lender))" class="btn-select w-100"
                    (click)="SelectLender(lender)">Select</button>
            </div>
        </div>
    </div>
    }
</div>

<!-- Rejected Lenders -->
@if(rejectedLenders.length > 0) {
<div class="section mx-3">
    <h2 class="text-danger">Rejected Lenders</h2>
    <div class="card-container">
        <div class="lender-card disabled row align-items-center p-3" *ngFor="let lender of rejectedLenders">
            <div class="col-12 col-md-2 d-flex align-items-center mb-2 mb-md-0">
                <img [src]="lender.logo" [alt]="lender.lender + ' logo'" class="logo me-2">
                <h3 class="mb-0">{{ lender.lender }}</h3>
            </div>
            <div class="col-12 col-md-10">
                <span class="text-muted">Application Not Approved</span>
            </div>
        </div>
    </div>
</div>
}

<!-- Edit Travel Details Popup -->
<div class="edit-travel-overlay" *ngIf="showEditPopup"></div>
<div class="edit-travel-popup" *ngIf="showEditPopup">
    <div class="row justify-content-center">
        <div class="col-9 col-sm-8 blue_box p-4 text-center">
            <h3 style="color: white; font-family: 'Noto Serif', serif;">Edit Travel Details</h3>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-12 col-sm-11 white_box p-4 position-relative">
            <button type="button" class="close" aria-label="Close" (click)="closeEditPopup()"
                style="position: absolute; right: 15px; top: 10px; font-size: 1.5rem; background: none; border: none; z-index: 10;">
                <span aria-hidden="true">&times;</span>
            </button>
            <div class="container-fluid page mt-4" style="text-align: left;">
                <form #editForm="ngForm" (ngSubmit)="updateTravelDetails()" autocomplete="off">
                    <div class="row">
                        <!-- Travel Type -->
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="travelType" class="control-label">Travel Type</label>
                                <select class="form-select" id="travelType" [(ngModel)]="travelDetails.travelType"
                                    name="travelType" required #travelType="ngModel"
                                    style="height: calc(1.5em + .75rem + 2px);">
                                    <option value="">Choose type of travel</option>
                                    <option value="flight">Flight</option>
                                    <option value="hotel">Hotel</option>
                                    <option value="holiday package">Holiday Package</option>
                                </select>
                                <div *ngIf="travelType.invalid && (travelType.dirty || travelType.touched)"
                                    class="error mt-1">
                                    <div *ngIf="travelType.errors?.['required']">Travel type is required.</div>
                                </div>
                            </div>
                        </div>

                        <!-- Travel Date -->
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="travelDate" class="control-label">Travel Date</label>
                                <input type="text" placeholder="Enter Travel Date"
                                    (bsValueChange)="handleTravelDateChange($event)" [minDate]="minDate"
                                    class="form-control" bsDatepicker [bsConfig]="bsConfig" [readOnly]="true" required
                                    [(ngModel)]="travelDetails.travelDate" name="travelDate" #travelDate="ngModel">
                                <div *ngIf="travelDate.invalid && (travelDate.dirty || travelDate.touched)"
                                    class="error mt-1">
                                    <div *ngIf="travelDate.errors?.['required']">Travel date is required.</div>
                                </div>
                            </div>
                        </div>

                        <!-- Travel Cost -->
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="travelCost" class="control-label">Travel Cost &#8377;</label>
                                <input type="number" class="form-control" placeholder="Your trip cost"
                                    [(ngModel)]="travelDetails.travelCost" required name="travelCost" min="10000"
                                    max="1000000" (input)="allowOnly($event, 'numbers')" #travelCost="ngModel">
                                <div *ngIf="travelCost.invalid && (travelCost.dirty || travelCost.touched)"
                                    class="error mt-1">
                                    <div *ngIf="travelCost.errors?.['required']">Travel cost is required.</div>
                                    <div *ngIf="travelCost.errors?.['min']">Travel cost must be at least 10,000.</div>
                                    <div *ngIf="travelCost.errors?.['max']">Travel cost cannot exceed 10,00,000.</div>
                                </div>
                            </div>
                        </div>

                        <!-- Origin -->
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="origin" class="control-label">Origin</label>
                                <input type="text" class="form-control" placeholder="From city"
                                    [(ngModel)]="travelDetails.origin" required name="origin" pattern="[a-zA-Z\s]{2,50}"
                                    minlength="2" maxlength="50"
                                    (input)="allowOnly($event, 'alphabets'); toUpperCase($event)" #origin="ngModel">
                                <div *ngIf="origin.invalid && (origin.dirty || origin.touched)" class="error mt-1">
                                    <div *ngIf="origin.errors?.['required']">Origin is required.</div>
                                    <div *ngIf="origin.errors?.['pattern']">Origin must contain only letters.</div>
                                    <div *ngIf="origin.errors?.['minlength']">Origin must be at least 2 characters long.
                                    </div>
                                    <div *ngIf="origin.errors?.['maxlength']">Origin cannot be more than 50 characters
                                        long.</div>
                                </div>
                            </div>
                        </div>

                        <!-- Destination -->
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label for="destination" class="control-label">Destination</label>
                                <input type="text" class="form-control" placeholder="To city"
                                    [(ngModel)]="travelDetails.destination" required name="destination"
                                    pattern="[a-zA-Z\s]{2,50}" minlength="2" maxlength="50"
                                    (input)="allowOnly($event, 'alphabets'); toUpperCase($event)"
                                    #destination="ngModel">
                                <div *ngIf="destination.invalid && (destination.dirty || destination.touched)"
                                    class="error mt-1">
                                    <div *ngIf="destination.errors?.['required']">Destination is required.</div>
                                    <div *ngIf="destination.errors?.['pattern']">Destination must contain only letters.
                                    </div>
                                    <div *ngIf="destination.errors?.['minlength']">Destination must be at least 2
                                        characters long.</div>
                                    <div *ngIf="destination.errors?.['maxlength']">Destination cannot be more than 50
                                        characters long.</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="text-center mt-3 field-group">
                        <button type="submit" class="btn btn-warning" [disabled]="editForm.invalid">Update</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>